import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';

const $api = {};

/**
 * 获取单位分组列表
 *
 * @date 2018-8-20 15:32:01
 *
 * @returns {Promise<any>}
 */
$api.getCompanyGroupList = ()=>{
    const url = "company/groups";
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 更新单位分组数据
 *
 * @param {array} data 待更新的数组
 *
 * @date 2018-8-20 17:19:31
 *
 * @returns {Promise<any>}
 */
$api.setCompanyGroupList = (data) => {
    const url = "company/groups";
    const promise = new Promise(resolve=>{
        $http.put(url,data).then(response=>{
                resolve(response);
        });
    });
    return promise;
};

/**
 * 验证单位分组下是否还才存在用户
 *
 * @param {string} gid 单位分组id
 *
 * @date 2018-9-6 14:29:24
 *
 * @returns {Promise<any>}
 */
$api.findGroupUsers = (gid) => {
    const url = `company/groups-users/${gid}`;
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            resolve(response);
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/group.js